import { useMemo } from 'react';

// Shared fallback logic for 3D trailer preview length:
// - use explicit form LF when valid
// - otherwise use computed shipment LF
export function useVisualizationLinearFeet(
  currentLinearFeet: unknown,
  computedLinearFeet: number
): number {
  return useMemo(() => {
    const parsedCurrentLinearFeet =
      typeof currentLinearFeet === 'number'
        ? currentLinearFeet
        : Number(currentLinearFeet);
    if (
      Number.isFinite(parsedCurrentLinearFeet) &&
      parsedCurrentLinearFeet > 0
    ) {
      return parsedCurrentLinearFeet;
    }
    return computedLinearFeet;
  }, [computedLinearFeet, currentLinearFeet]);
}
